import React from 'react';
import Select from 'react-select';

import './PrivacyAddressBook.css';

function PrivacyAddressBook(props) {

    const options = [
        { value: 0, label: "Add new account", name: "", address: "" }, 
        { value: 1, label: "GHOST #1 0xa12b...ff52 (default)", name: "GHOST #1", address: "0xa12b1235534534534111213ff52" }, 
        { value: 2, label: "GHOST #2 0xb153...9c32 (default)", name: "GHOST #2", address: "0xb153432423423a123167bbf9c32" }, 
        { value: 3, label: "GHOST #3 0x1bbb...6fa2 (default)", name: "GHOST #3", address: "0x1bbb14783931123123213156fa2" }, 
        { value: 4, label: "GHOST #4 0xbe11...57ef (default)", name: "GHOST #4", address: "0xbe11978febba1334389ff3257ef" }, 
        { value: 5, label: "GHOST #5 0x83b1...7baa (default)", name: "GHOST #5", address: "0x83b195757918abbff3737417baa" }, 
        { value: 6, label: "GHOST #6 0xc51f...faa1 (default)", name: "GHOST #6", address: "0xc51f32439896ba112312346faa1" }, 
        { value: 7, label: "GHOST #7 0xbc74...fa13 (default)", name: "GHOST #7", address: "0xbc74abbee888ff11773493bfa13" }, 
    ];

    const [newbie, setNewbie] = React.useState(true);
    const [address, setAddress] = React.useState("");
    const [name, setName] = React.useState("");
    const [selectedOption, setSelectedOption] = React.useState(options[0]);

    const changeAddress = (val) => {
        val = val.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
        setAddress(val);
    }

    const changeSelectedOption = (opt) => {
    	setSelectedOption(opt);
        if (opt.value === 0) {
	    setNewbie(false);
	} else {
            setNewbie(true);
	}
        console.log(selectedOption);
    }

    return (
        <div className="ghost-privacy-address-book-container">
	    <div className="ghost-privacy-transfer-header">
	        <div className="ghost-privacy-transfer-header-container">
	            <div className="ghost-privacy-transfer-header-container-title">Address Book</div>
	                <div className="ghost-privacy-transfer-header-container-text">Manage your decoys accounts.</div>
	            </div>
	    
	            <div className="ghost-privacy-transfer-balance">
	                <div className="ghost-privacy-transfer-balance-title">Balance</div>
	                <div className="ghost-privacy-transfer-balance-amount">3.2347 {props.asset}</div>
	            </div>
	    
	    </div>
	    
	    <div className="ghost-privacy-transfer-main">
	        <div className="ghost-privacy-transfer-main-receiver">
	            <input spellCheck="false" onChange={(val) => changeAddress(val.target.value)}  value={!newbie ? address : selectedOption.address} type="text" placeholder="New astral address" disabled={newbie ? "disabled" : ""}></input>
	        </div>
	        <div className="ghost-privacy-transfer-main-amount">
	            <input onChange={(val) => setName(val.target.value)} value={!newbie ? name : selectedOption.name} type="text" placeholder="Nickname for the address" disabled={newbie ? "disabled" : ""}></input>
	        </div>
	    </div>
	    
	    <div className="ghost-privacy-transfer-info">
	        <Select
	            defaultValue={selectedOption}
	            onChange={changeSelectedOption}
	            options={options}
	            className={"ghost-privacy-dropdown"}
	        />
	    </div>
	    
	    
	    <div className="ghost-propose-claim-buttons ghost-privacy-button-transfer">
	        <div onClick={() => {alert("transfered")}} className="ghost-propose-claim-buttons-button ghost-privacy-button-transfer-adapt">{!newbie ? "Add to address book" : "Remove from address book"}</div>
	    </div>

	</div>
    )
}

export default PrivacyAddressBook;
